<template>
  <div class="">
    
    <!-- 查询表单 -->
    <div>
      <el-form ref="alipyAccountSetForm" :model="alipyAccountSetForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item
              label="回收商"
              prop="serviceId"
            >
              <el-select
                style="width:100%"
                v-model="alipyAccountSetForm.serviceId"
                filterable
              >
                <el-option
                  v-for="item in queryServiceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="getSecretManageList">查询</el-button>
            <el-button type="primary" @click="addSecretManage">添加</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
            <!-- 表格 -->
       <el-table
        :data="tableData"
        border
        style="width: 100%">
          <el-table-column
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            prop="serviceName"
            label="回收商">
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0">已启用</span>
              <span v-else>已关闭</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作">
              <template slot-scope="scope">
                <el-button @click="editorSecretManage(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="open(scope.row.id)" type="text" size="small" v-if="scope.row.status === 1">开启</el-button>
                <el-button @click="close(scope.row.id)" type="text" size="small" style="color: red;" v-else>关闭</el-button>
                 <el-button @click="deleteSecretManage(scope.row.id)" type="text" size="small" >删除</el-button>
                </template>
          </el-table-column>
      </el-table>
      

      <!-- 分页 -->
      <el-pagination style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal">
      </el-pagination>
    </div>

    <!-- 修改或新建城市经理对话框 -->
    <el-dialog :title="dlgType === 'change' ? '编辑对接密钥' : '新建对接密钥'" :visible.sync="isDlg" width="700px">
      <div style="margin: 20px;">
        <div>
          <el-form ref="editalipyAccountSetForm" :model="editalipyAccountSetForm" :rules="editorFormRules" label-width="140px">
            <el-form-item label="ID" v-if="dlgType === 'change'">
              <el-input clearable v-model="editalipyAccountSetForm.id" :disabled="true"></el-input>
            </el-form-item>
           <el-form-item
              label="回收商"
              prop="serviceId"
            >
              <el-select
                style="width:100%"
                v-model="editalipyAccountSetForm.serviceId"
                filterable
                @change="getQuoteUserByServiceIds"
              >
                <el-option
                  v-for="item in queryServiceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="密钥" prop="secret">
              <el-input v-model="editalipyAccountSetForm.secret"></el-input>
            </el-form-item>
            <el-form-item label="第三方ID" prop="thirdOpenId">
              <textarea v-model="editalipyAccountSetForm.thirdOpenId" style="width: 100%;height: 90px;"></textarea>
            </el-form-item>
            <el-form-item label="第三方密钥" prop="thirdOpenSecret">
              <textarea v-model="editalipyAccountSetForm.thirdOpenSecret" style="width: 100%;height: 90px;"></textarea>
            </el-form-item>
            <el-form-item label="网关地址" prop="serverUrl">
              <el-input v-model="editalipyAccountSetForm.hookUrl"></el-input>
            </el-form-item>
            <el-form-item label="默认报价员" prop="quoteUserId">
              <el-select
                v-model="editalipyAccountSetForm.quoteUserId"
                filterable
                remote
                reserve-keyword
                >
                <el-option
                  v-for="item in quoteUserList"
                  :key="item.id"
                  :label="item.realName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button type="primary" style="margin: 30px 20px;" @click="submitEditor">确定</el-button>
          <el-button style="margin: 10px 20px;" @click="closeEditorDlg">暂不</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  data(){
    return {
      // 查询数据
      alipyAccountSetForm: {
        name: null
      },
      categoryOptions: [],

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      // 新建编辑对话框数据

      isDlg: false,
      editalipyAccountSetForm: {
        id: null,
        type: 1
      },

      editorFormRules: {
        categoryId: [
          { required: true, message: '请选择分类', trigger: 'change' },
        ],
        // tempGradeIdList: [
        //   { required: true, message: '请选择前端等级', trigger: 'change' },
        // ],
        autoPriceGradeId: [
          { required: true, message: '请选择出价等级', trigger: 'change' },
        ],
      },
      dlgType: 'change',
      queryGradeList:[],
      queryServiceList: [],
      quoteUserList:[]
    }
  },
  watch:{},
  computed:{},
  methods:{
    getQuoteUserByServiceIds(ids){
    let self = this;
     self.$api.getQuoteUserByServiceIds({
         serviceIdsStr:ids,
       }).then((res)=>{
          self.quoteUserList = res.data;
      });
    },
         //回收商集合
    getServiceList() {
      let self = this;
      this.$api.getValidHjxServiceProvider().then((res) => {
        self.queryServiceList = res.data || [];
      });
    },
    // 请求分类列表，提供编辑时选择用
    getSelectOptions(typeKey, optionName, categoryId) {
      let self = this;
      self.$api
        .getClass({
          categoryId: categoryId,
          typeKey: typeKey,
          status: 1,
          page: 1,
          size: 100000,
        })
        .then((res) => {
          if (res.code === 200) {
            self[optionName] = res.data.records;
          }
        });
    },
    deleteSecretManage(id){
      let self = this
        self.$confirm('是否删除').then(() => {
           self.$api.deleteSecretManage({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getSecretManageList()
          }
      })
      })
   
    },
    // 分页函数
    handleSizeChange(val) {
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1)
    },

    handleCurrentChange(val) {
      this.currentPage = val
      // 重新请求订单数据
      this.getSecretManageList()
    }, 
    //等级
    getGradeList(val) {
      let self = this;
        this.$api
            .getValidModelGrade({
              categoryId: self.editalipyAccountSetForm.categoryId,
            })
            .then((res) => {
              self.queryGradeList = res.data || [];
             
            });
    },

    // 获取门店列表
    getSecretManageList() {
      let self  = this;
      self.$api.listSearchSecretManage({
        page: self.currentPage,
        size: self.pageSize,
        serviceId: self.alipyAccountSetForm.serviceId || null
      }).then(res => {
        self.tableData = res.data.records || []
        self.tableTotal = res.data.total
      })
    },

    // 添加门店
    addSecretManage() {
      this.dlgType = 'new'
      this.editalipyAccountSetForm =  {
        id: null,
        type: "1"
      }
      this.$nextTick(()=>{
          this.$refs['editalipyAccountSetForm'].clearValidate()
      })
      this.isDlg = true
    },

    // 修改门店
    editorSecretManage(row) {
      let self = this;
      self.editalipyAccountSetForm=JSON.parse(JSON.stringify(row));
      self.dlgType = 'change'
      self.getQuoteUserByServiceIds(self.editalipyAccountSetForm.serviceId)
      this.$nextTick(()=>{
        self.isDlg = true
      })
    },

    // 关闭编辑对话框
    closeEditorDlg() {
      this.isDlg = false
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs['editalipyAccountSetForm'].validate((valid) => {
        if (valid) {
          if(self.dlgType === 'change') {
            self.$api.updateSecretManage(self.editalipyAccountSetForm).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.getSecretManageList()
                this.closeEditorDlg()
              }
            })
          } else {
            self.$api.addSecretManage(self.editalipyAccountSetForm).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                this.getSecretManageList()
                this.closeEditorDlg()
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
     
    },

    // 开启门店
    open(id) {
      let self = this
      this.$api.openSecretManage(id).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '开启成功',
            type: 'success'
          });
          self.getSecretManageList()
        }
      })
    },

    // 关闭门店
    close(id) {
      let self = this
      this.$api.closeSecretManage(id).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '关闭成功',
            type: 'success'
          });
          self.getSecretManageList()
        }
      })
    },

  },
  created(){
    
  },
  mounted(){
    let self = this;
    self.getSecretManageList();
    self.getServiceList()
  }
}
</script>
<style lang="less" scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>